<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="bar">
        <a-input v-model="query.keyword" placeholder="商品/用户/订单号/内容" style="width:280px" />
        <a-select v-model="query.star" allow-clear placeholder="评分" style="width:120px">
          <a-select-option v-for="n in 5" :key="n" :value="n">{{ n }} 星</a-select-option>
        </a-select>
        <a-select v-model="query.status" allow-clear placeholder="审核状态" style="width:140px">
          <a-select-option :value="0">待审核</a-select-option>
          <a-select-option :value="1">已通过</a-select-option>
          <a-select-option :value="2">违规</a-select-option>
        </a-select>
        <a-button type="primary" @click="load">查询</a-button>
        <a-button v-hasPermi="['dkmall:comment:design-display']" @click="$router.push('/dkmall/catalog/design-comment-display')">共享设计室评论展示配置</a-button>
      </div>
      <a-alert message="通过后前台正常展示；违规后前台隐藏并替换为固定文案。订单确认收货满20天未评价会自动生成五星好评。" type="info" show-icon />
      <a-table row-key="aid" :data-source="rows" :columns="columns" :pagination="pagination" @change="page" style="margin-top:16px">
        <template slot="goods" slot-scope="t, r"><div>{{ r.goods_name }}</div><small>货号 {{ r.goods_sn || '-' }}</small></template>
        <template slot="user" slot-scope="t, r"><div>{{ r.nickname || '-' }}</div><small>ID {{ r.user_id }} · {{ r.country || '' }}</small></template>
        <template slot="star" slot-scope="t, r"><a-rate :value="Number(r.star)" disabled /></template>
        <template slot="content" slot-scope="t, r">
          <div>{{ r.content }}</div><div style="display:flex;gap:6px;flex-wrap:wrap"><img v-for="(url,i) in commentImages(r.thumb)" :key="i" :src="url" v-image-preview style="width:56px;height:56px;object-fit:cover" /></div>
          <a-tag v-if="Number(r.is_auto) === 1" color="blue">系统默认</a-tag>
        </template>
        <template slot="status" slot-scope="t, r">
          <a-tag :color="statusMeta(r.status).color">{{ statusMeta(r.status).text }}</a-tag>
        </template>
        <template slot="op" slot-scope="t, r">
          <a @click="audit(r, 1)">通过</a>
          <a-divider type="vertical" />
          <a-popconfirm title="标记违规后前台将显示固定隐藏文案，确认？" @confirm="audit(r, 2)"><a>违规</a></a-popconfirm>
          <a-divider type="vertical" />
          <a @click="openReply(r)">{{ Number(r.is_replay) === 1 ? '查看回复' : '回复' }}</a>
        </template>
      </a-table>
      <a-drawer title="评价回复" width="600" :visible="visible" @close="visible = false">
        <a-list bordered :data-source="replies">
          <a-list-item slot="renderItem" slot-scope="item">{{ item.content }}<span>{{ time(item.create_time) }}</span></a-list-item>
        </a-list>
        <a-textarea v-model="reply" :rows="4" placeholder="输入商家回复" style="margin-top:16px" />
        <a-button type="primary" style="margin-top:12px" @click="submitReply">提交回复</a-button>
      </a-drawer>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listComments, listReplies, replyComment, setCommentStatus } from '@/api/dkmall/catalog-maintenance'

export default {
  name: 'DkGoodsComment',
  data() {
    return {
      query: { keyword: '', star: undefined, status: undefined, pageNum: 1, pageSize: 20 },
      rows: [],
      total: 0,
      visible: false,
      active: null,
      replies: [],
      reply: '',
      columns: [
        { title: '订单号', dataIndex: 'order_sn', width: 170 },
        { title: '商品', scopedSlots: { customRender: 'goods' }, width: 200 },
        { title: '用户', scopedSlots: { customRender: 'user' }, width: 130 },
        { title: '评分', scopedSlots: { customRender: 'star' }, width: 150 },
        { title: '评价内容', scopedSlots: { customRender: 'content' } },
        { title: '时间', dataIndex: 'create_time', customRender: v => this.time(v), width: 170 },
        { title: '审核', scopedSlots: { customRender: 'status' }, width: 90 },
        { title: '操作', scopedSlots: { customRender: 'op' }, width: 200 }
      ]
    }
  },
  computed: {
    pagination() {
      return { current: this.query.pageNum, pageSize: this.query.pageSize, total: this.total, showSizeChanger: true }
    }
  },
  created() {
    this.applyRouteQuery()
    this.load()
  },
  watch: {
    '$route.query'() {
      this.applyRouteQuery()
      this.query.pageNum = 1
      this.load()
    }
  },
  methods: {
    applyRouteQuery() {
      const status = this.$route.query.status
      if (status !== undefined && status !== null && status !== '') {
        this.query.status = Number(status)
      }
    },
    commentImages(value) { if(Array.isArray(value)) return value; try { const rows=JSON.parse(value); if(Array.isArray(rows)) return rows.map(r=>typeof r==='string'?r:r.url||r.path).filter(Boolean) } catch(e) {} return String(value||'').split(',').filter(Boolean) },
    load() {
      listComments(this.query).then(r => {
        this.rows = (r.data && r.data.rows) || []
        this.total = Number((r.data && r.data.total) || 0)
      })
    },
    page(p) { this.query.pageNum = p.current; this.query.pageSize = p.pageSize; this.load() },
    time(v) { return v ? new Date(Number(v) * 1000).toLocaleString() : '-' },
    statusMeta(v) {
      const status = Number(v)
      if (status === 1) return { color: 'green', text: '已通过' }
      if (status === 2) return { color: 'red', text: '违规' }
      return { color: 'orange', text: '待审核' }
    },
    audit(r, status) {
      setCommentStatus(r.aid, status).then(() => {
        this.$message.success(status === 1 ? '已通过' : '已标记违规')
        this.load()
      })
    },
    openReply(r) {
      this.active = r
      this.reply = ''
      this.visible = true
      listReplies(r.aid).then(x => { this.replies = x.data || [] })
    },
    submitReply() {
      if (!this.reply) return this.$message.warning('请输入回复内容')
      replyComment(this.active.aid, { content: this.reply }).then(() => {
        this.reply = ''
        this.openReply(this.active)
        this.load()
      })
    }
  }
}
</script>

<style scoped>
.bar { display: flex; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.ant-rate { font-size: 16px; }
</style>
